import { createStore } from "solid-js/store";

interface AutoLoginState {
  isAutoLogin: boolean;
  isTokenLogin: boolean;
  bChangeToken: boolean;
}

const [autoLoginState, setAutoLoginState] = createStore<AutoLoginState>({
  isAutoLogin: false,
  isTokenLogin: false,
  bChangeToken: false,
});

export const updateAutoLoginState = (updates: Partial<AutoLoginState>) => {
  setAutoLoginState(updates);
};

export const getAutoLoginState = () => autoLoginState;
